module.exports = __webpack_public_path__ + "img/locations_static_map.png";